import { StyleSheet, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { AppText } from '@/components/AppText';
import { CustomDivider } from "@/components/CustomDivider";
import Head from 'expo-router/head';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import { Link } from 'expo-router';
import Footer from '@/components/Footer';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import { ExternalLink } from '@/components/ExternalLink';
import { Image } from 'expo-image';
import * as AppUtilities from '@/utilities/AppUtilities';
import { Button } from 'react95-native-rabbl';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
  },
  playStoreImage: {
    width: 174,
    height: 52,
  },
  appStoreImage: {
    width: 200,
    height: 59,
  },
  appStoreImage2: {
    width: 200,
    height: 68,
  },
  appStoreImage3: {
    width: 174,
    height: 59,
  },
  header: {
    //fontSize: AppConsts.DEFAULT_FONT_SIZE + 2,
    fontStyle: "italic",
    //fontWeight: "300",
    //textDecorationLine: "underline",
  },
  answer: {
    paddingLeft: 20,
  },
});

const headerStyle = styles.header;
//const headerStyle = CustomTextStyles.medium;

const answerStyle = styles.answer;

export default function FAQ() {
  const isMainLogicalHost = useSelector((state: RootState) => state.user.isMainLogicalHost);

  return (
    <BasicScrollView center={false}>
      <Meta title={"FAQs"} />
      <AppText>Some frequently asked questions (FAQs) and answers:</AppText>
      <CustomDivider fullWidth={true} />
      <CustomText>For daters</CustomText>
      <AppText style={headerStyle}>What's a Rabbl?</AppText>
      <AppText style={answerStyle}>One definition of a rabble is <Link href="https://ucanr.edu/blog/bug-squad/article/whats-group-butterflies-called" target="_blank" style={CustomTextStyles.link}>a group of butterflies</Link>. The idea is to date people within the groups you like.</AppText>
      <AppText style={answerStyle}>There's a separate Rabbl for each community. For example, each music band could have their own Rabbl. Members only see dating profiles for people in the Rabbls they've joined.</AppText>
      <AppText style={headerStyle}>Can I join multiple Rabbls?</AppText>
      <AppText style={answerStyle}>Yep! You can re-use your dating profile for multiple Rabbls or create a different one for each.</AppText>
      <AppText style={headerStyle}>Why is there a cover charge to join any Rabbl?</AppText>
      <AppText style={answerStyle}>The cover charge is a one time fee to join any Rabbl. It reduces scammers, helps fund Rabbl, and the owner of the Rabbl gets paid which incentivizes them to market their Rabbls and grow the community.</AppText>
      <AppText style={answerStyle}>We're all about transparency. We tell you upfront how many people are in the Rabbl (including the number of men and women) and there's a map to show where members are to help you decide if you want to join.</AppText>
      {
        AppUtilities.isWeb() &&
          <>
            <AppText style={headerStyle}>How can I pay to join?</AppText>
            <AppText style={answerStyle}>{AppConsts.PAYMENTS_LINE1}</AppText>
            <View style={[AppConstants.STYLES.flexRow, answerStyle]}>
              {
                isMainLogicalHost ?
                    <Link href="/findrabbl" asChild={true} className={"nontext"}><Button>Join with credit card</Button></Link>
                  :
                    <Link href="/join" asChild={true} className={"nontext"}><Button>Join with credit card</Button></Link>
              }
            </View>
            <View style={[AppConstants.STYLES.horizontal1Wrap, answerStyle]}>
              <Link href="/joinapple" asChild={AppUtilities.isWeb()}>
                <Image source={require('@/assets/images/testflight174x59.png')} style={styles.appStoreImage3} />
              </Link>
            </View>
            <View style={[AppConstants.STYLES.horizontal1Wrap, answerStyle]}>
              <ExternalLink href={AppConsts.ANDROID_STORE_LINK} target='_blank' asChild={AppUtilities.isWeb()}>
                <Image source={require('@/assets/images/playstore174x52.png')} style={styles.playStoreImage} />
              </ExternalLink>
            </View>
          </>
      }
      <AppText style={headerStyle}>Why do some profiles show "Collab with ..."?</AppText>
      <AppText style={answerStyle}>Rabbl owners may choose to form a collaboration where members of both Rabbls see each other's profiles.</AppText>

      <CustomDivider fullWidth={true} />

      <CustomText>For creators</CustomText>

      <AppText style={headerStyle}>What's the cost to create a Rabbl?</AppText>
      <AppText style={answerStyle}>Free</AppText>
      <AppText style={headerStyle}>Who can create a Rabbl?</AppText>
      <AppText style={answerStyle}>Anyone can propose a new Rabbl and we'll review. Right now, we're only accepting those that have a following and/or a clear marketing plan.</AppText>
      <AppText style={headerStyle}>What percent of the cover charge does the owner of a Rabbl get?</AppText>
      <AppText style={answerStyle}>{AppConsts.CREATOR_CUT} {/*<Link href="https://www.youtube.com/watch?v=xlCPkmb6cuY" target="_blank" style={CustomTextStyles.link}>We're all in it together</Link>*/}</AppText>
      <AppText style={headerStyle}>Can a Rabbl be invite only?</AppText>
      <AppText style={answerStyle}>Yes</AppText>

      <CustomDivider fullWidth={true} />
      
      <CustomText>General</CustomText>

      <AppText style={headerStyle}>What the heck is your aesthetic?</AppText>
      <AppText style={answerStyle}><Link href="/aesthetic" style={CustomTextStyles.link}>𝕒𝕖𝕤𝕥𝕙𝕖𝕥𝕚𝕔?  (◔◡◔)</Link></AppText>
      <AppText style={headerStyle}>Any other question?</AppText>
      <AppText style={answerStyle}><Link href="/contact" style={CustomTextStyles.link}>Contact us</Link></AppText>
      <Footer />
    </BasicScrollView>
  );
}
